import { render, staticRenderFns } from "./AchievementsComponent.vue?vue&type=template&id=2e15587f&scoped=true"
import script from "./AchievementsComponent.vue?vue&type=script&lang=js"
export * from "./AchievementsComponent.vue?vue&type=script&lang=js"
import style0 from "./AchievementsComponent.vue?vue&type=style&index=0&id=2e15587f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e15587f",
  null
  
)

export default component.exports